import microApp from '@ecoflow/ef-micro';
import lifeCycles from '@/configu/lifecycles';

microApp.start({
    lifeCycles,
    excludeAssetFilter(assetUrl) {
        // 指定部分特殊的动态加载的微应用资源（css/js) 不被 micro-app 劫持处理
        return assetUrl.includes('//maps.googleapis.com');
    },
    plugins: {
        global: [
            {
                // 可以逃逸到外部的全局变量(escapeProperties中的变量会同时赋值到子应用和外部真实的window上)
                escapeProperties: ['__googleMapsCallback', 'maps', 'google'],
            },
        ],
    },
});
